import React from "react";
import PropTypes from "prop-types";
import styled from "react-emotion";
import { isEmpty, replace } from "ramda";

import { colors } from "../consts";
import Tooltip from "./Tooltip";

const width = 180;
const dotted = "2px dotted #ababab";

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  min-height: 700px;
  display: flex;
  flex-direction: column;
`;
const AverageText = styled.h5`
  color: #7c7c7c;
  margin: 8px 0 0 6px;
  font-size: 12px;
  border-bottom: ${dotted};
  padding-bottom: 3px;
  transform: translateY(3px);
  width: calc(${({ width }) => width} - 4px);
  min-width: 95px;
`;
const Container = styled.div`
  position: relative;
  width: ${width}px;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 15px 0 5px 0;
  overflow: hidden;
`;
const AverageLine = styled.div`
  position: absolute;
  left: ${({ left }) => left};
  height: 100%;
  width: 0;
  border-left: ${dotted};
  pointer-events: none;
  box-shadow: 0 0 3px 1px rgba(255, 255, 255, 0.3);
`;
const CountyBlock = styled.a`
  display: block;
  flex: 1;
  width: 100%;
  position: relative;
  transition: opacity 0.2s;
  opacity: ${({ hovered }) => (hovered ? 1 : 0.7)};
  cursor: pointer;
  &:hover {
    opacity: 1;
    z-index: 1;
  }
`;
const Bar = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
`;
const Text = styled.span`
  position: absolute;
  top: 50%;
  left: 6px;
  color: black;
  font-size: 11px;
  line-height: 10px;
  font-weight: 400;
  transition: transform 0.2s;
  transform: translate(${({ hovered }) => (hovered ? 6 : 0)}px, -50%);
  span {
    font-weight: 600;
  }
  &::after {
    content: "";
    position: absolute;
    left: -12px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 0 5px 6px;
    border-color: transparent transparent transparent ${colors.primaryDark};
  }
`;

export default class CountyList extends React.Component {
  static propTypes = {
    indicatorData: PropTypes.object.isRequired,
    hoveredCounty: PropTypes.string,
    setHoveredCounty: PropTypes.func.isRequired
  };

  render() {
    const {
      indicatorData,
      hoveredCounty,
      setHoveredCounty,
      dataSheetUrl
    } = this.props;

    return (
      <Wrapper>
        <AverageText width={`${indicatorData.averageRatio}%`}>
          Montana: {indicatorData.averageString}
        </AverageText>

        <Container>
          {indicatorData.countyList.map(county => {
            const hovered = `${hoveredCounty} County` === county.name;
            return (
              <CountyBlock
                key={county.name}
                hovered={hovered}
                onMouseEnter={() => {
                  // give onMouseLeave event's setState time to finish
                  setTimeout(() => {
                    setHoveredCounty(replace(" County", "", county.name));
                  }, 10);
                }}
                onMouseLeave={() => {
                  setHoveredCounty(null);
                }}
                href={dataSheetUrl}
                target="_blank"
                data-tip={`
                <div>
                  <h5 class="tooltip-download">Click to download Data Sheet (PDF)</h5>
                </div>
              `}
                data-place="right"
                data-delay-show={500}
              >
                <Bar
                  style={{
                    width: county.width,
                    backgroundColor: county.backgroundColor
                  }}
                />
                <Text hovered={hovered}>
                  {county.name}: <span>{county.valueString}</span>
                </Text>
              </CountyBlock>
            );
          })}

          <AverageLine left={`${indicatorData.averageRatio}%`} />
        </Container>

        <Tooltip />
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CountyList.js